import ApiClient from "./ApiClient";

export function fetchApplicationFromContext(context) {
    return ApiClient.get('/open/applications/context/check?context=' + context);
}